import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../controls/Modal';

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
const roman = (n) => ROMAN[n - 1] || String(n);

// Модалка завершения мероприятия: назначение итогового места каждой команде.
export default function FinishActivityModal({ event, colorOf, onSubmit, onClose }) {
    const teams = event.teamOdds || [];
    const [results, setResults] = useState({});

    const placeOptions = useMemo(
        () => Array.from({ length: teams.length }, (_, i) => i + 1),
        [teams.length]
    );

    const setPlace = (teamId) => (e) => setResults(prev => ({ ...prev, [teamId]: e.target.value }));
    const valid = teams.every(t => results[t.teamId]);

    const submit = async () => {
        if (!valid) return;
        try {
            await onSubmit(event.id, teams.map(t => ({ teamId: t.teamId, place: Number(results[t.teamId]) })));
            onClose();
        } catch (e) { /* ошибку покажет хук */ }
    };

    return (
        <Modal
            open
            kicker="Мероприятие"
            title={`Завершить · ${event.title}`}
            onClose={onClose}
            footer={(
                <>
                    <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
                    <button type="button" className="btn btn-primary" onClick={submit} disabled={!valid}>Завершить мероприятие</button>
                </>
            )}
        >
            <div>
                <div className="me-hint">Назначьте итоговое место каждой команде</div>
                <div className="me-places">
                    {teams.map(team => (
                        <div key={team.teamId} className="me-row">
                            <div className="me-team"><span className="bdot" style={{ background: colorOf(team.teamId) }} />{team.teamName}</div>
                            <select className="ev-sel" value={results[team.teamId] || ''} onChange={setPlace(team.teamId)}>
                                <option value="" disabled>—</option>
                                {placeOptions.map(p => (
                                    <option key={p} value={p}>{roman(p)}</option>
                                ))}
                            </select>
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
}

FinishActivityModal.propTypes = {
    event: PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string,
        teamOdds: PropTypes.array
    }).isRequired,
    colorOf: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
